import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=31b09d6a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b09d6a')) {
      api.createRecord('31b09d6a', component.options)
    } else {
      api.reload('31b09d6a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=31b09d6a&", function () {
      api.rerender('31b09d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tHAhwZVo8U9Y/JS/comp/IncreaseNumber.vue"
export default component.exports